import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import AmpToolTip from "../AmpToolTip/AmpToolTip";

import "./AmpCaptcha.css";

export default function AmpCaptcha() {

    const { t, i18n } = useTranslation('login');
    const recaptchaRef = React.useRef();

    const i8Lang = i18n.language.split("-")[0]
    const [lang, setLang] = useState("en");
    const [key, setKey] = useState(0);
    const size = window.innerWidth > 500 ? "normal" : "compact";
    const captchaDisabledFlag = process.env?.REACT_APP_DISABLE_CAPTCHA;
    const captchaEnabled = !(captchaDisabledFlag === "1");

    if (lang !== i8Lang) {
        setLang(i8Lang);
        setKey(key + 1);
    }

    return (
        <div>
            <div className="inline-captcha">
                {captchaEnabled && (
                    <>
                        <ReCAPTCHA
                            size={size}
                            key={key}
                            ref={recaptchaRef}
                            hl={lang}
                            sitekey={process.env.REACT_APP_CAPTCHA_PUB}
                        />
                        <AmpToolTip id="captcha-tooltip" content={t("robot-tooltip") as string} direction="top" />
                    </>
                )}

            </div>
        </div>
    )
}